import { render, staticRenderFns } from "./HeaderUserInfo.vue?vue&type=template&id=339f36b3&"
import script from "./HeaderUserInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserInfo.vue?vue&type=style&index=0&id=339f36b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports